module.exports = __webpack_public_path__ + "img/step3.82802c52.png";